export default "__VITE_ASSET__0733ab37__"